export enum AppLanguage {
    English = 'en',
    French = 'fr'
}

export const AppLanguageCultures = new Map([
    [AppLanguage.English.toString(), 'en-US'],
    [AppLanguage.French.toString(), 'fr-FR']
]);